// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gfu-url-field__actions[data-v-6b7981d1]{width:80px;text-align:right}`, "",{"version":3,"sources":["webpack://./Client/Src/Components/UrlField.vue"],"names":[],"mappings":"AACA,yCACI,UAAA,CACA,gBAAA","sourcesContent":["\n.gfu-url-field__actions {\n    width: 80px;\n    text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
